export default Object.freeze({
  FieldValidationModes: {
    NotPrompted: 0,
    Optional: 1,
    Mandatory: 2
  }
});
